<template>
  <div class="container">
    <div class="nav">
      <template v-if="scrollable">
        <span class="icon prev" @click="scrollPrev" v-if="navOffset">
          <img :src="ossPath + '/pages/home/icon_page_left.png'" alt="左">
        </span>
        <span class="icon next" @click="scrollNext" v-if="scrollable.next">
          <img :src="ossPath + '/pages/home/icon_page_right.png'" alt="右">
        </span>
      </template>
      <div style="transition: transform .3s" id="list">
        <div class="tab_wrap" ref="tab_scroll">
          <div class="tab" id="tab" style="transition: transform .3s">
            <div id="arrow"></div>
            <div class="tab-item" v-for="(item, index) in list" :key="item.id"
                 :class="{'tab-item-active': currentIndex === index}" @click="tabClick(item, index)" :id="`tab${index}`">
              {{ item.transportSchemeName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "transportationPlanTab",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0,
      tabObj: null,
      scrollable: {
        prev: 0,
        next: true
      },
      navOffset: 0,
    }
  },
  watch: {
    list() {
      // this.currentIndex = 0
      this.$nextTick(() => {
        // this.tabScroll(0)
        if (this.tabObj) this.tabObj.style.transform = `translateX(0px)`
      })
    }
  },
  mounted() {
    this.tabObj = document.getElementById('tab')
    this.$nextTick(() => {
      this.tabScroll(0)
    })
    this.computeScrollable()
  },
  updated() {
    this.$nextTick(() => {
      this.computeScrollable()
    })
  },
  methods: {
    tabClick(item, index) {
      // this.currentIndex = index
      // this.scrollToActiveTab()
      if (index === this.currentIndex) return
      this.tabScroll(index)
      this.$emit('change', item)
    },
    tabScroll(index) {
      this.currentIndex = index
      this.$nextTick(() => {
        const tabItem = document.getElementById(`tab${index}`)
        const arrow = document.getElementById('arrow')
        const to = tabItem.offsetLeft + tabItem.scrollWidth / 2 - arrow.scrollWidth
        arrow.style.transform = `translate(${to}px) rotate(45deg)`
      })
    },
    scrollPrev() {
      const containerWidth = this.$refs.tab_scroll.offsetWidth
      // let list = document.getElementById('list')
      let currentOffset = this.navOffset
      let newOffset = currentOffset > containerWidth
        ? currentOffset - containerWidth
        : 0
      // list.style.transform = `translateX(${newOffset}px)`
      this.tabObj.style.transform = `translateX(-${newOffset}px)`
      this.navOffset = newOffset;
    },
    scrollNext() {
      // let list = document.getElementById('list')
      const navSize = this.tabObj.offsetWidth
      const containerSize = this.$refs.tab_scroll.offsetWidth
      const currentOffset = this.navOffset;

      if (navSize - currentOffset <= containerSize) return;

      let newOffset = navSize - currentOffset > containerSize * 2
        ? currentOffset + containerSize
        : (navSize - containerSize);
      // list.style.transform = `translateX(-${newOffset}px)`
      this.tabObj.style.transform = `translateX(-${newOffset}px)`
      this.navOffset = newOffset;
    },
    scrollToActiveTab() {
      if (!this.scrollable) return
      let list = document.getElementById('list')
      const nav = this.tabObj;
      const activeTab = document.querySelector('.tab-item-active')
      const navScroll = this.$refs.tab_scroll;
      const activeTabBounding = activeTab.getBoundingClientRect();
      const navScrollBounding = navScroll.getBoundingClientRect();
      const maxOffset = nav.offsetWidth - navScrollBounding.width
      const currentOffset = this.navOffset;
      let newOffset = currentOffset;
      console.log(activeTabBounding, navScrollBounding)
      if (activeTabBounding.left < navScrollBounding.left) {
        newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
      }
      if (activeTabBounding.right > navScrollBounding.right) {
        newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
      }
      newOffset = Math.max(newOffset, 0);
      newOffset = Math.min(newOffset, maxOffset);
      this.navOffset = newOffset
      console.log(this.navOffset)
      list.style.transform = `translateX(-${newOffset}px)`
    },
    // 计算是否展示左右滚动按钮
    computeScrollable() {
      const navSize = this.tabObj.offsetWidth
      const containerSize = this.$refs.tab_scroll.offsetWidth
      const currentOffset = this.navOffset;
      if (containerSize < navSize) {
        this.scrollable = this.scrollable || {};
        this.scrollable.prev = currentOffset;
        this.scrollable.next = currentOffset + containerSize < navSize;
        if (navSize - currentOffset < containerSize) {
          this.navOffset = navSize - containerSize;
          // this.tabObj.style.transform = `translateX(-${this.navOffset}px)`
        }
      } else {
        this.scrollable = false
        if (currentOffset > 0) {
          this.navOffset = 0;
          // this.tabObj.style.transform = `translateX(-${this.navOffset}px)`
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  position:relative;
  .nav {
    overflow: hidden;
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 3px;
      background: #FF4D01;
      float: left;
    }
  }
}
.tab_wrap {
  display: block;
  height: 60px;
  position: relative;
}
.tab {
  float: left;
  margin-top: 23px;
  box-sizing: border-box;
  background: transparent;
  position: relative;
  white-space: nowrap;
  &-item {
    height: 36px;
    flex-shrink: 0;
    padding-bottom: 18px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 1;
    box-sizing: border-box;
    margin-right: 75px;
    cursor: pointer;
    display: inline-block;
    &:last-child {
      margin-right: 0;
    }
    &-active {
      color: #FF4D01;
    }
  }
}
#arrow {
  width: 12px;
  height: 12px;
  display: inline-block;
  border: 3px solid #FF4D01;
  background: #F5F5F5;
  transform: translateX(-50%) rotate(45deg);
  transition: transform .3s cubic-bezier(.645, .045, .355, 1);
  position: absolute;
  bottom: -13px;
  left: 0;
}
.icon {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  font-size: 18px;
  vertical-align: bottom;
  background: transparent;
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  i {
    font-size: 20px;
    font-weight: 500;
    color: #999;
  }
}
$icon-distance: -44px;
.prev {
  left: $icon-distance;
  top: 50%;
  transform: translateY(-50%);
}
.next {
  right: $icon-distance;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/transportationPlanTab.vue